import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CopyrightAlertService {
  private copyrightAcceptedSubject = new BehaviorSubject<boolean>(false);
  public copyrightAccepted$ = this.copyrightAcceptedSubject.asObservable();

  constructor() { }

  // Verifica se o usuário já aceitou os termos de direitos autorais
  isCopyrightAccepted(): boolean {
    return this.copyrightAcceptedSubject.value;
  }

  // Marca que o usuário aceitou os termos
  acceptCopyright(): void {
    this.copyrightAcceptedSubject.next(true);
  }

  // Reseta o estado (útil para logout ou mudança de usuário)
  resetCopyrightAcceptance(): void {
    this.copyrightAcceptedSubject.next(false);
  }

  // Força a exibição do pop-up (útil para mudança de relatório)
  forceShowCopyrightAlert(): void {
    this.copyrightAcceptedSubject.next(false);
  }
}
